export default __webpack_public_path__ + "static/media/solar-unselected.c1fc227e.png";